import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StoreState {
    storeId?: string;
    isMayaveStore?: string;
    storedataid?: string;
    mayavePurityEdit?: string;
    roleName?: string;
    isMainStore?: string;
    token?: string;
}

const initialState: StoreState = {
    storeId: undefined,
    isMayaveStore: undefined,
    storedataid: undefined,
    mayavePurityEdit: undefined,
    roleName: undefined,
    isMainStore: undefined,
    token: undefined,
};

const storeSlice = createSlice({
    name: "adminAction",
    initialState,
    reducers: {
        setStoreField: (
            state,
            action: PayloadAction<{ key: keyof StoreState; value: string | undefined }>
        ) => {
            state[action.payload.key] = action.payload.value;
        },
        setAllStoreData: (state, action: PayloadAction<StoreState>) => {
            return { ...state, ...action.payload };
        },
        clearStoreData: () => initialState,
        clearStoreField: (state, action: PayloadAction<keyof StoreState>) => {
            state[action.payload] = undefined;
        },
    },
});

export const {
  setStoreField,
  setAllStoreData,
  clearStoreData,
  clearStoreField,
} = storeSlice.actions;

export default storeSlice.reducer;
